import api from '../../utils/api'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormGenerator from './Form/FormGenerator'

function EditGenerator({id , btCancelAction, handleOnSuccess}){
    const [generator, setGenerator] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    /* const {id} = useParams() */
    
    const {setFlashMessage} = useFlashMessage()
    const navigate = useNavigate()

    useEffect(() => {

        api.get(`/generator/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
            
        }).then((response) => {
            
            setGenerator(response.data.generator)
        })
    }, [token, id])

    async function updateGenerator(generator) {
        let msgType = 'success'
        
        
        const data = await api.patch(`generator/update/${generator._id}`, generator, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {
            
            return response.data
        }).catch((err) => {
            
            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            /* navigate('/generator') */
            }

    }


    return (
        <section>
            {generator.name && (
                <FormGenerator title="Editar Gerador" handleSubmit={updateGenerator} btnText="Salvar" btCancelAction={btCancelAction} generatorData={generator} />
            )}
        </section>
    )
}

export default EditGenerator